<template>
  <div class="input-group custom-picker-container">
    <input
      type="text"
      ref="picker"
      class="form-control picker-input"
      :value="formattedValue"
      placeholder="เลือกวันที่และเวลา"
    />

    <div class="input-group-append">
      <span class="input-group-text">
        <b-icon icon="calendar-event"></b-icon>
      </span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";

export default {
  props: ["value", "options", "fieldName", "courseInfo"],
  methods: {
    formatThaiDate(dateValue) {
      if (!dateValue) return "";
      const dateMoment = moment(dateValue);
      if (!dateMoment.isValid()) return "";

      const thaiYear = dateMoment.year() + 543;
      return dateMoment.format(`DD-MM-[${thaiYear}] HH:mm:ss`);
    },
    // Restores input value back to Thai format when picker closes/cancels
    resetInputValue() {
      const formatted = this.formattedValue;
      $(this.$refs.picker).val(formatted);
    },
    formatToGregorian(thaiDateStr) {
      if (!thaiDateStr) return "";

      // 1. Split into date and time
      const [datePart, timePart] = thaiDateStr.trim().split(" ");
      const [day, month, yearStr] = datePart.split("-");

      let year = parseInt(yearStr, 10);
      year -= 543;

      // 3. Pass explicit format string to moment
      const standardStr = `${year}-${month}-${day} ${timePart || ""}`.trim();
      return moment(standardStr, "YYYY-MM-DD HH:mm:ss").format(
        "YYYY-MM-DD HH:mm:ss",
      );
    },
  },
  computed: {
    formattedValue() {
      if (this.value === "" || this.value === null) return "";

      let rawDate = this.value;
      if (rawDate === undefined && this.courseInfo) {
        const fieldMap = {
          OPEN_ORDER: this.courseInfo.openOrderDateTime,
          CLOSE_ORDER: this.courseInfo.closeOrderDateTime,
          OPEN_PAYMENT: this.courseInfo.openPaymentDateTime,
          CLOSE_PAYMENT: this.courseInfo.closePaymentDateTime,
        };
        rawDate = fieldMap[this.fieldName];
      }

      return rawDate ? this.formatThaiDate(rawDate) : "";
    },
  },
  mounted() {
    const pickerElement = $(this.$refs.picker);

    const options = {
      ...this.options,
      parentEl: $(this.$el),
    };

    pickerElement.daterangepicker(options);

    $(this.$el)
      .find(".input-group-text")
      .on("click", function() {
        pickerElement.focus();
      });

    pickerElement.on("show.daterangepicker", (ev, picker) => {
      if (this.formattedValue) {
        const targetMoment = this.formatToGregorian(this.formattedValue);

        picker.setStartDate(targetMoment);

        // สั่ง Re-render UI ทันทีในการเปิดครั้งแรก
        picker.updateCalendars();
      }
    });

    pickerElement.on("apply.daterangepicker", (ev, picker) => {
      const value = picker.startDate.format(this.options.locale.format);
      this.$emit("input", value);
    });

    pickerElement.on("cancel.daterangepicker", (ev) => {
      $(ev.currentTarget).val("");
      this.$emit("input", "");
    });
  },
  watch: {
    options: {
      handler(newOptions) {
        const picker = $(this.$refs.picker).data("daterangepicker");
        if (picker) {
          if (newOptions.minDate)
            picker.minDate = moment(
              newOptions.minDate,
              this.options.locale.format,
            );
          if (newOptions.maxDate)
            picker.maxDate = moment(
              newOptions.maxDate,
              this.options.locale.format,
            );

          picker.updateView();
        }
      },
      deep: true,
    },
    // Ensure input updates if value prop updates from parent
    value() {
      this.$nextTick(() => {
        this.resetInputValue();
      });
    },
  },
  beforeDestroy() {
    if ($(this.$refs.picker).data("daterangepicker")) {
      $(this.$refs.picker)
        .data("daterangepicker")
        .remove();
    }
  },
};
</script>

<style scoped>
.daterangepicker {
  z-index: 3000 !important;
  margin-top: 5px;
}

.picker-input {
  border-right: none;
  font-family: sans-serif;
  color: #333;
}

.input-group-text {
  border-left: none;
  color: #444;
  cursor: pointer;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.custom-picker-container:focus-within {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
